export default class Accordion {
  constructor() {

    this.accordions = [...document.querySelectorAll('.accordion > .accordion__btn')];
		this.accordions.forEach(item => {
			item.addEventListener('click', this.spnavsubClick.bind(this));
    });

    this.init();
  }

  init(){
    
  }


  spnavsubClick(e) {
    e.preventDefault();
    let target = e.target;
    let child = target.nextElementSibling;
    let parent = target.parentNode;
    // console.log(target.parentNode);
    if(!parent.classList.contains("is_active")) {
      parent.classList.add('is_active');
      child.style.height = child.scrollHeight + 'px';
    } else {
      parent.classList.remove('is_active');
      child.style.height = 0;
    }
  }

}
